export const myProfileInitialState = {
    isRender: false,
    isFirst: false
};

export const MyProfileActionTypes = {
    UPDATE_IS_RENDER: 'UPDATE_IS_RENDER',
    UPDATE_IS_FIRST: 'UPDATE_IS_FIRST'
};
